// src/pages/Schedule/UpcomingSessions.jsx

import React from "react";
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  Divider,
  Box
} from "@mui/material";
import SessionItem from "./SessionItem";

export default function UpcomingSessions({
  sessions = [],
  onMarkCompleted,
  onEdit
}) {
  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 3,
        overflow: "hidden"
      }}
    >
      <CardContent
        sx={{
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 2.5 }
        }}
      >
        {sessions.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              py: 5,
              borderRadius: 2,
              backgroundColor: "#f9fafb",
              border: "1px dashed #e5e7eb"
            }}
          >
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: { xs: "0.9rem", sm: "1rem" }
              }}
            >
              No upcoming sessions scheduled
            </Typography>
          </Box>
        ) : (
          <List disablePadding>
            {sessions.map((session, index) => (
              <React.Fragment key={session.id}>
                <ListItem
                  disableGutters
                  sx={{
                    px: 0,
                    py: { xs: 1.5, sm: 2 }
                  }}
                >
                  <SessionItem
                    session={session}
                    onMarkCompleted={onMarkCompleted}
                    onEdit={onEdit}
                  />
                </ListItem>

                {index !== sessions.length - 1 && (
                  <Divider />
                )}
              </React.Fragment>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
}